<template>
  <div>
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>学校筛选标签</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content">
      <el-form inline label-position="right" size="small" class="query-form">
        <el-form-item>
          <el-button type="success" @click="openDialog('category')">添加一级分类</el-button>
          <span class="form-tip" style="margin-left:12px">仅有一级、不建二级时，可在学校编辑里直接选该一级名称作为标签</span>
        </el-form-item>
      </el-form>

      <el-card class="box-card table">
        <el-tree
          v-if="treeData.length"
          :data="treeData"
          node-key="id"
          default-expand-all
          :expand-on-click-node="false"
          :props="treeProps"
          :render-content="renderContent"
        ></el-tree>
        <el-empty v-else description="暂无标签，请先添加一级分类"></el-empty>
      </el-card>
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="480px" :destroy-on-close="true" @opened="dialogOpened">
      <el-form :model="form" ref="form" label-width="100px" @submit.native.prevent="submitForm">
        <el-form-item v-if="dialogType === 'tag'" label="所属分类" prop="parentID">
          <el-select v-model="form.parentID" placeholder="请选择一级分类" style="width: 100%">
            <el-option
              v-for="item in categoryList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="名称"
          prop="title"
          :rules="[{ required: true, message: '请输入名称' }]"
        >
          <el-input v-model="form.title" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item v-if="dialogType === 'category'" label="选中图标">
          <div id="uploadSchoolLabelIconActive" class="uploader uploader-warning"></div>
          <img
            :src="domain + form.imgUrl"
            style="height: 40px; margin-left: 10px; vertical-align: middle"
            v-if="form.imgUrl"
          />
          <div class="form-tip">分类选中时显示，建议 48×48 绿色透明 PNG</div>
        </el-form-item>
        <el-form-item v-if="dialogType === 'category'" label="未选中图标">
          <div id="uploadSchoolLabelIconInactive" class="uploader uploader-warning"></div>
          <img
            :src="domain + form.imgUrl2"
            style="height: 40px; margin-left: 10px; vertical-align: middle"
            v-if="form.imgUrl2"
          />
          <div class="form-tip">分类未选中时显示，建议 48×48 灰色透明 PNG</div>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model.number="form.sort" placeholder="数字越大越靠前"></el-input>
        </el-form-item>
        <el-form-item label="是否启用">
          <el-switch v-model="form.isEnable"></el-switch>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">保存</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";

export default {
  name: "schoolLabel",
  data() {
    return {
      domain: url.getDomain(),
      modelid: 5,
      treeData: [],
      categoryList: [],
      treeProps: {
        children: "children",
        label: "label",
      },
      dialogVisible: false,
      dialogTitle: "",
      dialogType: "category",
      submiting: false,
      form: {},
    };
  },
  methods: {
    loadTree: function () {
      var _this = this;
      var link = url.getSys_BasicData("GetBaseTree");
      $.get(link, { modelid: _this.modelid }, function (data) {
        _this.treeData = (data || []).map(function (p) {
          return {
            id: p.id,
            label: p.label,
            imgUrl: p.imgUrl || "",
            imgUrl2: p.imgUrl2 || "",
            children: (p.children || []).map(function (c) {
              return {
                id: c.id,
                label: c.label,
              };
            }),
          };
        });
        _this.categoryList = _this.treeData.map(function (p) {
          return { id: p.id, label: p.label };
        });
      });
    },
    editNode: function (data, node) {
      if (node.level === 1) {
        this.openDialog("category", data);
      } else {
        this.openDialog("tag", data);
      }
    },
    openDialog: function (type, node, parentNode) {
      this.dialogType = type;
      if (type === "category") {
        this.dialogTitle = node ? "编辑一级分类" : "添加一级分类";
        if (node) {
          this.loadModel(node.id);
        } else {
          this.form = { isEnable: true, sort: 0, parentID: null };
        }
      } else {
        this.dialogTitle = node ? "编辑二级标签" : "添加二级标签";
        if (node) {
          this.loadModel(node.id);
        } else {
          this.form = {
            isEnable: true,
            sort: 0,
            parentID: parentNode ? parentNode.id : null,
          };
        }
      }
      this.dialogVisible = true;
    },
    loadModel: function (id) {
      var _this = this;
      var link = url.getSys_BasicData("GetModel_BasicData");
      $.get(link, { id: id }, function (data) {
        _this.form = data;
        _this.dialogType = data.parentID ? "tag" : "category";
        _this.dialogTitle = data.parentID ? "编辑二级标签" : "编辑一级分类";
      });
    },
    dialogOpened: function () {
      var _this = this;
      if (_this.dialogType !== "category") {
        return;
      }
      _this.$nextTick(function () {
        _this.initCategoryUploaders();
      });
    },
    initCategoryUploaders: function () {
      var _this = this;
      $("#uploadSchoolLabelIconActive").empty();
      $("#uploadSchoolLabelIconInactive").empty();
      $("#uploadSchoolLabelIconActive").uploader({
        url: url.getUpload(),
        text: "上传选中图标",
        type: "single",
        fileExts: "jpg;png;gif;webp",
        handleType: "0",
        more: false,
        maxSize: 1024 * 1024 * 2,
        onSuccess: function (data) {
          _this.$set(_this.form, "imgUrl", data.relativeName);
        },
      });
      $("#uploadSchoolLabelIconInactive").uploader({
        url: url.getUpload(),
        text: "上传未选中图标",
        type: "single",
        fileExts: "jpg;png;gif;webp",
        handleType: "0",
        more: false,
        maxSize: 1024 * 1024 * 2,
        onSuccess: function (data) {
          _this.$set(_this.form, "imgUrl2", data.relativeName);
        },
      });
    },
    submitForm: function () {
      var _this = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) return;
        var info = Object.assign({}, _this.form);
        info.modelid = _this.modelid;
        if (!info.code) {
          info.code = "L5_" + (info.id || Date.now());
        }
        if (_this.dialogType === "category") {
          info.parentID = null;
        } else if (!info.parentID) {
          _this.$message({ type: "error", message: "请选择所属分类" });
          return;
        }
        _this.submiting = true;
        var link = url.getSys_BasicData("Save_BasicData");
        $.post(link, info, function (res) {
          _this.submiting = false;
          if (res.status) {
            _this.dialogVisible = false;
            _this.loadTree();
            _this.$message({ type: "success", message: res.msg });
          } else {
            _this.$message({ type: "error", message: res.msg });
          }
        });
      });
    },
    removeNode: function (node, data) {
      var _this = this;
      var hasChild = data.children && data.children.length;
      var msg = hasChild
        ? "该一级分类下还有二级标签，删除将同时删除其下所有二级标签，确定继续？"
        : "确定删除吗？";
      this.$confirm(msg, "提示", { type: "warning" })
        .then(function () {
          // 先子后父，避免外键级联报错
          var ids = [];
          if (hasChild) {
            data.children.forEach(function (c) {
              ids.push(c.id);
            });
          }
          ids.push(data.id);
          var link = url.getSys_BasicData("Delete_BasicData");
          $.post(link, { idList: ids.join(",") }, function (res) {
            if (res.status) {
              _this.loadTree();
              _this.$message({ type: "success", message: res.msg });
            } else {
              _this.$message({ type: "error", message: res.msg || "删除失败" });
            }
          });
        })
        .catch(function () {});
    },
    renderCategoryIcons: function (h, data) {
      var _this = this;
      if (!data.imgUrl && !data.imgUrl2) {
        return null;
      }
      var icons = [];
      if (data.imgUrl) {
        icons.push(
          h("img", {
            attrs: { src: _this.domain + data.imgUrl, alt: "选中" },
            style: "width:20px;height:20px;margin-right:4px;vertical-align:middle",
          })
        );
      }
      if (data.imgUrl2) {
        icons.push(
          h("img", {
            attrs: { src: _this.domain + data.imgUrl2, alt: "未选中" },
            style: "width:20px;height:20px;margin-right:4px;vertical-align:middle;opacity:0.55",
          })
        );
      }
      return h("span", { style: "display:inline-flex;align-items:center" }, icons);
    },
    renderContent: function (h, { node, data }) {
      var _this = this;
      var isRoot = node.level === 1;
      return h("span", { class: "custom-tree-node" }, [
        h("span", [
          isRoot ? _this.renderCategoryIcons(h, data) : null,
          node.label,
        ]),
        h("span", { class: "tree-actions" }, [
          h(
            "el-button",
            {
              props: { type: "text", size: "mini" },
              on: {
                click: function () {
                  _this.editNode(data, node);
                },
              },
            },
            "编辑"
          ),
          isRoot
            ? h(
                "el-button",
                {
                  props: { type: "text", size: "mini" },
                  on: {
                    click: function () {
                      _this.openDialog("tag", null, data);
                    },
                  },
                },
                "添加标签"
              )
            : null,
          h(
            "el-button",
            {
              props: { type: "text", size: "mini" },
              style: { color: "#f56c6c" },
              on: {
                click: function () {
                  _this.removeNode(node, data);
                },
              },
            },
            "删除"
          ),
        ]),
      ]);
    },
  },
  mounted() {
    this.loadTree();
  },
};
</script>

<style scoped>
.query-form {
  margin-top: 20px;
  padding: 15px 15px 5px;
  background: #f2f2f2;
}
.box-card.table {
  margin-top: 0;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.tree-actions .el-button {
  padding: 0 6px;
}
.form-tip {
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
  margin-top: 6px;
}
</style>

<style>
.el-tree-node__content {
  height: 36px;
}
</style>
